import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
  conditionalRow: {
    backgroundColor: '#ffcccc',
    '&:hover': {
      backgroundColor: '#fcb0b1 !important'
    }
  },
  form: {
    display: 'flex'
  },
  input: {
    flexGrow: 1
  }
}))

export default useStyles
